const membershipStatuses = [
  'loggedOut',
  'vip',
  'downgraded',
  'postreg',
  'lead',
];
export default membershipStatuses;
